import { useState } from 'react';

interface ServiceDetail {
  title: string;
  description: string;
  items: string[];
  priceRange: string;
  icon: string;
}

const serviceDetails: Record<string, ServiceDetail> = {
  foto: {
    title: 'Foto & Cetak Foto',
    description: 'Layanan lengkap untuk semua kebutuhan fotografi dan cetak foto Anda dengan kualitas terbaik.',
    items: [
      'Cetak foto ukuran 3R hingga 24R',
      'Pas foto berbagai ukuran (2x3, 3x4, 4x6)',
      'Foto produk profesional dengan studio mini',
      'Paket prewedding lengkap dengan bingkai',
      'Restorasi foto lama yang rusak atau pudar',
      'Cetak dari klise/film analog',
      'Laminating foto untuk perlindungan ekstra'
    ],
    priceRange: 'Mulai dari Rp 2.000',
    icon: 'ri-camera-line'
  },
  desain: {
    title: 'Desain & Percetakan',
    description: 'Solusi desain grafis dan percetakan untuk branding bisnis dan kebutuhan promosi Anda.',
    items: [
      'Desain logo profesional dan modern',
      'Banner, spanduk, dan X-banner',
      'Brosur, flyer, dan katalog produk',
      'Desain menu restoran dan cafe',
      'Stiker A3, stiker label makanan, stiker UV',
      'Kartu nama premium',
      'Kalender custom tahunan',
      'Buku Yasin & Tahlil untuk acara',
      'Jersey dan kaos sablon DTF berkualitas'
    ],
    priceRange: 'Mulai dari Rp 15.000',
    icon: 'ri-palette-line'
  },
  servis: {
    title: 'Servis Laptop & HP',
    description: 'Perbaikan dan perawatan laptop serta HP dengan teknisi berpengalaman dan garansi resmi.',
    items: [
      'Install ulang Windows & aktivasi Office',
      'Pembersihan menyeluruh & ganti thermal paste',
      'Perbaikan casing laptop yang rusak',
      'Ganti LCD/layar laptop dan HP',
      'Ganti baterai original dan compatible',
      'Ganti keyboard laptop semua merk',
      'Upgrade HDD ke SSD untuk performa maksimal',
      'Ganti charger dan port charging',
      'Servis software: virus, lemot, error',
      'Servis hardware: mati total, overheat',
      'Pengecekan GRATIS sebelum servis'
    ],
    priceRange: 'Mulai dari Rp 60.000',
    icon: 'ri-computer-line'
  },
  cctv: {
    title: 'CCTV, LED & Elektronik',
    description: 'Instalasi dan maintenance sistem keamanan CCTV serta produk LED custom untuk bisnis Anda.',
    items: [
      'Pasang CCTV rumah dan toko (2MP-8MP)',
      'Setting remote CCTV via HP',
      'Servis dan maintenance CCTV',
      'Running text LED indoor/outdoor',
      'Jam digital masjid (jadwal sholat, suhu, tanggal)',
      'Plang toko LED menarik',
      'Papan nama LED custom',
      'Videotron LED untuk promosi',
      'Konsultasi gratis sistem keamanan'
    ],
    priceRange: 'Mulai dari Rp 150.000',
    icon: 'ri-webcam-line'
  },
  plts: {
    title: 'PLTS & Sepeda Listrik',
    description: 'Solusi energi terbarukan dengan panel surya dan servis sepeda listrik profesional.',
    items: [
      'Pemasangan PLTS untuk rumah tinggal',
      'PLTS untuk UMKM dan warung',
      'Setting inverter dan sistem baterai',
      'Konsultasi hemat listrik dengan solar',
      'Servis sepeda listrik semua merk',
      'Ganti dinamo dan motor listrik',
      'Perbaikan controller sepeda listrik',
      'Ganti baterai lithium',
      'Servis rem dan komponen mekanik',
      'Tune-up sepeda listrik berkala'
    ],
    priceRange: 'Mulai dari Rp 20.000 (servis sepeda)',
    icon: 'ri-sun-line'
  },
  digital: {
    title: 'Undangan Digital & Website',
    description: 'Buat undangan digital interaktif dan website sederhana untuk bisnis atau acara spesial Anda.',
    items: [
      'Undangan digital website pernikahan',
      'Undangan aqiqah dan khitanan',
      'Undangan ulang tahun interaktif',
      'Fitur RSVP dan konfirmasi tamu',
      'Galeri foto dan video',
      'Google Maps lokasi acara',
      'Musik background pilihan',
      'Website simple untuk UMKM',
      'Landing page jasa dan produk',
      'QR code custom untuk menu digital',
      'QR code kontak dan link sosial media'
    ],
    priceRange: 'Mulai dari Rp 35.000',
    icon: 'ri-smartphone-line'
  }
};

export default function Services() {
  const [selectedService, setSelectedService] = useState<string | null>(null);

  const services = [
    {
      id: 'foto',
      icon: 'ri-camera-line',
      title: 'Foto & Cetak Foto',
      description: 'Cetak foto 3R–24R, pas foto, foto produk, prewedding, restorasi foto lama',
      color: 'from-blue-500 to-blue-600'
    },
    {
      id: 'desain',
      icon: 'ri-palette-line',
      title: 'Desain & Percetakan',
      description: 'Logo, banner, spanduk, stiker, kartu nama, jersey, kaos sablon DTF',
      color: 'from-purple-500 to-purple-600'
    },
    {
      id: 'servis',
      icon: 'ri-computer-line',
      title: 'Servis Laptop & HP',
      description: 'Install ulang, ganti LCD, baterai, keyboard, servis software & hardware',
      color: 'from-green-500 to-green-600'
    },
    {
      id: 'cctv',
      icon: 'ri-webcam-line',
      title: 'CCTV, LED & Elektronik',
      description: 'Pasang CCTV, running text LED, jam digital masjid, plang toko LED',
      color: 'from-red-500 to-red-600'
    },
    {
      id: 'plts',
      icon: 'ri-sun-line',
      title: 'PLTS & Sepeda Listrik',
      description: 'Panel surya rumah & UMKM, servis sepeda listrik lengkap',
      color: 'from-yellow-500 to-orange-500'
    },
    {
      id: 'digital',
      icon: 'ri-smartphone-line',
      title: 'Undangan Digital & Website',
      description: 'Undangan website pernikahan, aqiqah, website UMKM, QR code custom',
      color: 'from-pink-500 to-rose-600'
    }
  ];

  return (
    <>
      <section id="services" className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <div className="inline-block mb-4">
              <span className="text-[#FF8A00] font-semibold text-sm uppercase tracking-wider bg-orange-50 px-4 py-2 rounded-full">
                Layanan Kami
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-[#0B1F3B] mb-4">
              Semua Kebutuhan Digital & Servis
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Dari cetak foto hingga panel surya, kami siap membantu Anda
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
            {services.map((service, index) => (
              <div
                key={index}
                className="group bg-white rounded-2xl border-2 border-gray-100 hover:border-[#FF8A00] transition-all duration-300 overflow-hidden hover:shadow-xl"
              >
                <div className={`bg-gradient-to-br ${service.color} p-8 text-white relative overflow-hidden`}>
                  <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -mr-16 -mt-16"></div>
                  <div className="relative z-10">
                    <div className="w-16 h-16 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-2xl mb-4">
                      <i className={`${service.icon} text-4xl`}></i>
                    </div>
                    <h3 className="text-2xl font-bold mb-2">{service.title}</h3>
                  </div>
                </div>

                <div className="p-6">
                  <p className="text-gray-600 mb-6 leading-relaxed min-h-[80px]">
                    {service.description}
                  </p>

                  <button
                    onClick={() => setSelectedService(service.id)}
                    className="mt-6 w-full bg-gradient-to-r from-[#0B1F3B] to-[#0d2847] text-white py-3 rounded-xl font-semibold hover:shadow-lg transition-all duration-300 flex items-center justify-center gap-2 group-hover:gap-3 whitespace-nowrap cursor-pointer"
                  >
                    Detail Layanan
                    <i className="ri-arrow-right-line text-lg"></i>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Service Detail Modal */}
      {selectedService && (
        <div
          className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedService(null)}
        >
          <div
            className="bg-white rounded-3xl max-w-3xl w-full max-h-[90vh] overflow-y-auto shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="sticky top-0 bg-gradient-to-r from-[#0B1F3B] to-[#0d2847] text-white p-6 rounded-t-3xl flex items-center justify-between">
              <div className="flex items-center gap-4">
                <div className="w-14 h-14 flex items-center justify-center bg-[#FF8A00] rounded-xl">
                  <i className={`${serviceDetails[selectedService].icon} text-3xl`}></i>
                </div>
                <h3 className="text-2xl font-bold">{serviceDetails[selectedService].title}</h3>
              </div>
              <button
                onClick={() => setSelectedService(null)}
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-all cursor-pointer"
              >
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>

            <div className="p-8">
              <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                {serviceDetails[selectedService].description}
              </p>

              <div className="bg-orange-50 border-l-4 border-[#FF8A00] p-4 rounded-lg mb-6">
                <div className="flex items-center gap-2 text-[#FF8A00] font-semibold mb-1">
                  <i className="ri-price-tag-3-line text-xl"></i>
                  <span>Harga</span>
                </div>
                <p className="text-[#0B1F3B] font-bold text-xl">
                  {serviceDetails[selectedService].priceRange}
                </p>
              </div>

              <h4 className="text-xl font-bold text-[#0B1F3B] mb-4 flex items-center gap-2">
                <i className="ri-list-check text-[#FF8A00]"></i>
                Detail Layanan
              </h4>

              <ul className="space-y-3 mb-8">
                {serviceDetails[selectedService].items.map((item, index) => (
                  <li key={index} className="flex items-start gap-3 text-gray-700">
                    <i className="ri-checkbox-circle-fill text-[#FF8A00] text-xl mt-0.5 flex-shrink-0"></i>
                    <span className="leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>

              <div className="bg-gray-50 rounded-2xl p-6 border border-gray-200">
                <p className="text-sm text-gray-600 mb-4 flex items-start gap-2">
                  <i className="ri-information-line text-[#FF8A00] text-lg mt-0.5"></i>
                  <span>Harga dapat berubah sesuai kondisi dan spesifikasi. Hubungi kami untuk konsultasi gratis dan penawaran terbaik.</span>
                </p>

                <a
                  href="https://wa.me/6285868360910"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full bg-[#25D366] hover:bg-[#20bd5a] text-white py-4 rounded-xl font-semibold text-lg transition-all duration-300 flex items-center justify-center gap-3 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-whatsapp-fill text-2xl"></i>
                  Konsultasi via WhatsApp
                  <i className="ri-arrow-right-line text-xl"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
